import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, { type EmblaOptionsType } from 'embla-carousel'
import {
	getAttributeOrThrow,
	qsaOptional,
	qsRequired,
} from '@/scripts/core/global'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'

export class BaSlider extends UcoastEl {
	static htmlSelector = 'ba-slider'
	uniqueId: string
	startIndex: number
	constructor() {
		super()
		this.uniqueId = getAttributeOrThrow('data-unique-id', this)
		this.loadSlidesInView = this.loadSlidesInView.bind(this)
		this.startIndex = parseInt(getAttributeOrThrow('data-start-index', this))
	}

	override animateIn() {
		super.animateIn()
		void this.initializeSlider()
	}

	initializeSlider() {
		const OPTIONS: EmblaOptionsType = {
			slidesToScroll: 1,
			align: 'center',
			containScroll: 'keepSnaps',
			dragFree: true,
			duration: 20,
			dragThreshold: 20,
			loop: true,
			startIndex: this.startIndex
		}

		const viewportNode = qsRequired('.embla__viewport', this)
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
		])
		emblaApi.on('init', () => {
			window.setTimeout(() => {
				this.loadSlidesInView()
				this.pauseSlidesOutsideView()
			}, 100)
		})
		emblaApi.on('slidesInView', () => {
			this.loadSlidesInView()
			this.pauseSlidesOutsideView()
		})
	}
	loadSlidesInView() {
		qsaOptional('.is-in-view', this)?.forEach((slide) => {
			void window.Ucoast.mediaManager.loadAllInContainer(slide)
		})
	}
	pauseSlidesOutsideView() {
		qsaOptional('[data-embla-slide]:not(.is-in-view)', this)?.forEach((slide) => {
			void window.Ucoast.mediaManager.pauseAllInContainer(slide)
		})
	}
}
